import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import { Toast } from "vant";
import { Dialog } from "vant";
import "vant/lib/index.css";
import { post, get, put, deleteMethod } from "./common/js/utils";
import SlideVerify from "vue-monoplasty-slide-verify";
import md5 from "js-md5";
import VueClipboard  from 'vue-clipboard2'


 
Vue.use( VueClipboard )
Vue.config.productionTip = false;
Vue.use(Vant);
Vue.use(SlideVerify);
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$put = put;
Vue.prototype.$delete = deleteMethod;
Vue.prototype.$md5 = md5;

router.beforeEach((to, from, next) => {
  console.log(to);
  console.log(to.path==="/scanner");
  if (to.path === "/voucherList") {
    document.title = to.query.title;
  } else if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
